<template>
  <v-app>
    <v-app-bar
      flat
      height="72"
      color="surface"
      :elevation="1"
      class="px-4 main-app-bar"
    >
      <!-- Mobil menü ikon -->
      <v-app-bar-nav-icon class="d-md-none" @click="drawer = !drawer" />

      <!-- Cím csak desktopon -->
      <v-app-bar-title class="font-weight-bold text-h6 d-none d-md-block">
        {{ studioSettings.brand.desktopTitle }}
      </v-app-bar-title>
      <div class="mobile-brand d-md-none">
        <img
          v-if="studioSettings.brand.logoUrl"
          :src="studioSettings.brand.logoUrl"
          alt="VSK logó"
          class="mobile-brand-logo"
        />
        <div class="mobile-brand-title">
          {{ studioSettings.brand.mobileTitle }}
        </div>
        <div class="mobile-brand-subtitle">
          {{ studioSettings.brand.mobileSubtitle }}
        </div>
      </div>

      <!-- Navigáció desktopon -->
      <div class="desktop-nav-shell d-none d-md-flex ml-6">
        <v-tabs
          v-model="activeTab"
          class="desktop-tabs"
          bg-color="transparent"
          align-with-title
          @click="resetProfileActive"
        >
          <!-- Fórum mindig látszik -->
          <v-menu offset-y>
            <template #activator="{ props }">
              <v-tab v-bind="props">
                <v-icon start size="16">mdi-post-outline</v-icon>Blog
              </v-tab>
            </template>

            <v-list density="compact" class="modern-menu-list">
              <v-list-item
                :to="{ name: 'forum-page' }"
                prepend-icon="mdi-view-dashboard-outline"
              >
                <v-list-item-title>Blog főoldal</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="profile?.Permission?.power >= 100"
                prepend-icon="mdi-plus-circle-outline"
                @click="showPostDialog = true"
              >
                <v-list-item-title>Új bejegyzés</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Csak bejelentkezve látható menük -->
          <template v-if="profile?.username">
            <v-tab
              v-if="profile?.Permission?.power >= 100"
              :to="{ name: 'users-page' }"
            >
              <v-icon start size="16">mdi-account-multiple-outline</v-icon
              >Felhasználók
            </v-tab>
            <v-menu v-if="profile?.Permission?.power >= 500" offset-y>
              <template #activator="{ props }">
                <v-tab v-bind="props">
                  <v-icon start size="16">mdi-tools</v-icon>Fejlesztői
                </v-tab>
              </template>
              <v-list density="compact" class="modern-menu-list">
                <v-list-item
                  :to="{ name: 'developer-tools-page' }"
                  prepend-icon="mdi-cog-outline"
                >
                  <v-list-item-title>Eszközök</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-frontend-studio-page' }"
                  prepend-icon="mdi-palette-outline"
                >
                  <v-list-item-title>Frontend Stúdió</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-errors-page' }"
                  prepend-icon="mdi-alert-circle-outline"
                >
                  <v-list-item-title>Hibák</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-emails-page' }"
                  prepend-icon="mdi-email-outline"
                >
                  <v-list-item-title>Levelek</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-audit-page' }"
                  prepend-icon="mdi-history"
                >
                  <v-list-item-title>Audit</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-statistics-settings-page' }"
                  prepend-icon="mdi-chart-box-outline"
                >
                  <v-list-item-title>Statisztika beállítás</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- Játékok -->
            <v-menu offset-y>
              <template #activator="{ props }">
                <v-tab v-bind="props">
                  <v-icon start size="16">mdi-gamepad-variant-outline</v-icon
                  >Játékok
                </v-tab>
              </template>
              <v-list density="compact" class="modern-menu-list">
                <v-list-item
                  :to="{ name: 'games-page' }"
                  prepend-icon="mdi-view-dashboard-outline"
                >
                  <v-list-item-title>Játékok főoldal</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="profile?.Permission?.power >= 100"
                  prepend-icon="mdi-plus-circle-outline"
                  @click="openGameDialog()"
                >
                  <v-list-item-title>Új játék</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-tab v-if="canViewStatistics" :to="{ name: 'statistics-page' }">
              <v-icon start size="16">mdi-chart-line</v-icon>Statisztikák
            </v-tab>

            <!-- Pályák -->
            <v-menu offset-y>
              <template #activator="{ props }">
                <v-tab v-bind="props">
                  <v-icon start size="16">mdi-map-marker-outline</v-icon>Pályák
                </v-tab>
              </template>
              <v-list density="compact" class="modern-menu-list">
                <v-list-item
                  :to="{ name: 'maps-page' }"
                  prepend-icon="mdi-view-dashboard-outline"
                >
                  <v-list-item-title>Pályák főoldal</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="profile?.Permission?.power >= 100"
                  prepend-icon="mdi-plus-circle-outline"
                  @click="showMapDialog = true"
                >
                  <v-list-item-title>Új pálya</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-tabs>
      </div>

      <v-spacer />

      <!-- Jobb oldali gombok -->
      <template #append>
        <v-chip
          v-if="profile?.username"
          class="mr-2 d-none d-md-inline-flex desktop-user-chip"
          color="primary"
          variant="tonal"
        >
          <v-icon start size="16">mdi-shield-account-outline</v-icon>
          {{ profile.username }}
        </v-chip>

        <!-- Bejelentkezés gomb csak desktopon -->
        <v-btn
          v-if="!profile?.username"
          :to="{ name: 'login-page' }"
          variant="outlined"
          color="primary"
          class="mr-2 d-none d-md-inline-flex"
        >
          <v-icon left>mdi-login</v-icon> Bejelentkezés
        </v-btn>

        <!-- Ikonok ha be van jelentkezve -->
        <v-btn v-if="profile?.username" icon variant="text" @click="logoutUser">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
        <v-btn
          v-if="profile?.username"
          icon
          variant="text"
          @click="goToProfile"
          :class="{ 'profile-active': isProfileActive }"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>

        <!-- Téma váltó -->
        <v-btn icon variant="text" @click="toggleTheme">
          <v-icon>{{ themeIcon }}</v-icon>
        </v-btn>
      </template>
    </v-app-bar>

    <!-- Mobil drawer -->
    <v-navigation-drawer
      v-model="drawer"
      temporary
      location="left"
      class="d-md-none mobile-drawer"
      color="surface"
    >
      <div class="mobile-drawer-header">
        <div>
          <img
            v-if="studioSettings.brand.logoUrl"
            :src="studioSettings.brand.logoUrl"
            alt="VSK logó"
            class="drawer-brand-logo"
          />
          <p class="mobile-drawer-overline mb-1">Navigáció</p>
          <h3 class="mobile-drawer-title mb-0">
            {{ studioSettings.brand.drawerTitle }}
          </h3>
        </div>
        <v-chip
          v-if="profile?.Permission?.name"
          size="small"
          color="primary"
          variant="flat"
        >
          {{ profile.Permission.name }}
        </v-chip>
      </div>

      <v-divider class="mb-3" />

      <div v-if="profile?.username" class="mobile-quick-actions">
        <v-btn
          block
          variant="tonal"
          color="primary"
          prepend-icon="mdi-post-outline"
          @click="
            showPostDialog = true;
            drawer = false;
          "
        >
          Új blogbejegyzés
        </v-btn>
        <v-btn
          v-if="profile?.Permission?.power >= 100"
          block
          variant="tonal"
          color="success"
          prepend-icon="mdi-gamepad-variant-outline"
          @click="openGameDialog(true)"
        >
          Új játék
        </v-btn>
        <v-btn
          v-if="profile?.Permission?.power >= 100"
          block
          variant="tonal"
          color="info"
          prepend-icon="mdi-map-marker-plus-outline"
          @click="
            showMapDialog = true;
            drawer = false;
          "
        >
          Új pálya
        </v-btn>
      </div>

      <v-list nav density="comfortable" class="mobile-nav-list">
        <template v-if="!profile?.username">
          <v-list-item
            :to="{ name: 'forum-page' }"
            prepend-icon="mdi-post-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Blog</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'login-page' }"
            prepend-icon="mdi-login"
            @click="drawer = false"
          >
            <v-list-item-title>Bejelentkezés</v-list-item-title>
          </v-list-item>
        </template>

        <template v-else>
          <v-list-item
            :to="{ name: 'forum-page' }"
            prepend-icon="mdi-post-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Blog</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'games-page' }"
            prepend-icon="mdi-gamepad-variant-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Játékok</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'maps-page' }"
            prepend-icon="mdi-map-marker-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Pályák</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canViewStatistics"
            :to="{ name: 'statistics-page' }"
            prepend-icon="mdi-chart-line"
            @click="drawer = false"
          >
            <v-list-item-title>Statisztikák</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'profile-page' }"
            prepend-icon="mdi-account-circle-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Profil</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="profile?.Permission?.power >= 100"
            :to="{ name: 'users-page' }"
            prepend-icon="mdi-account-multiple-outline"
            @click="drawer = false"
          >
            <v-list-item-title>Felhasználók</v-list-item-title>
          </v-list-item>
          <v-expansion-panels flat class="mobile-expansions">
            <v-expansion-panel v-if="profile?.Permission?.power >= 500">
              <v-expansion-panel-title>
                <v-icon class="mr-2" size="18">mdi-tools</v-icon> Fejlesztői
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-list-item
                  :to="{ name: 'developer-tools-page' }"
                  prepend-icon="mdi-cog-outline"
                  @click="drawer = false"
                >
                  <v-list-item-title>Eszközök</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-frontend-studio-page' }"
                  prepend-icon="mdi-palette-outline"
                  @click="drawer = false"
                >
                  <v-list-item-title>Frontend Stúdió</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-errors-page' }"
                  prepend-icon="mdi-alert-circle-outline"
                  @click="drawer = false"
                >
                  <v-list-item-title>Hibák</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-emails-page' }"
                  prepend-icon="mdi-email-outline"
                  @click="drawer = false"
                >
                  <v-list-item-title>Levelek</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-audit-page' }"
                  prepend-icon="mdi-history"
                  @click="drawer = false"
                >
                  <v-list-item-title>Audit</v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'developer-statistics-settings-page' }"
                  prepend-icon="mdi-chart-box-outline"
                  @click="drawer = false"
                >
                  <v-list-item-title>Statisztika beállítás</v-list-item-title>
                </v-list-item>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main class="app-main">
      <v-container fluid class="app-content">
        <!-- Játék létrehozása dialog -->
        <!-- Dialog a játék létrehozásához -->
        <v-dialog v-model="showGameDialog" max-width="600px" persistent>
          <v-card class="elevation-10 rounded-lg">
            <v-card-title class="text-h5 font-weight-bold">
              <v-icon left>mdi-gamepad</v-icon> Új játék létrehozása
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <!-- Alapadatok szakasz -->
                <v-divider class="my-4" />
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="newGame.name"
                      label="Játék neve"
                      prepend-inner-icon="mdi-gamepad-variant"
                      outlined
                      dense
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <div class="editor-shell mb-2">
                      <div class="editor-toolbar">
                        <v-btn
                          size="small"
                          :variant="
                            gameEditorToolbarState.bold ? 'flat' : 'text'
                          "
                          :color="gameEditorToolbarState.bold ? 'primary' : ''"
                          icon="mdi-format-bold"
                          @click="applyGameEditorCommand('bold')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            gameEditorToolbarState.italic ? 'flat' : 'text'
                          "
                          :color="
                            gameEditorToolbarState.italic ? 'primary' : ''
                          "
                          icon="mdi-format-italic"
                          @click="applyGameEditorCommand('italic')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            gameEditorToolbarState.underline ? 'flat' : 'text'
                          "
                          :color="
                            gameEditorToolbarState.underline ? 'primary' : ''
                          "
                          icon="mdi-format-underline"
                          @click="applyGameEditorCommand('underline')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            gameEditorToolbarState.unorderedList
                              ? 'flat'
                              : 'text'
                          "
                          :color="
                            gameEditorToolbarState.unorderedList
                              ? 'primary'
                              : ''
                          "
                          icon="mdi-format-list-bulleted"
                          @click="applyGameEditorCommand('insertUnorderedList')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            gameEditorToolbarState.orderedList ? 'flat' : 'text'
                          "
                          :color="
                            gameEditorToolbarState.orderedList ? 'primary' : ''
                          "
                          icon="mdi-format-list-numbered"
                          @click="applyGameEditorCommand('insertOrderedList')"
                        />
                        <v-btn
                          size="small"
                          :variant="gameEditorToolbarState.h2 ? 'flat' : 'text'"
                          :color="gameEditorToolbarState.h2 ? 'primary' : ''"
                          @click="applyGameEditorCommand('formatBlock', 'h2')"
                        >
                          H2
                        </v-btn>
                        <v-btn
                          size="small"
                          :variant="gameEditorToolbarState.h3 ? 'flat' : 'text'"
                          :color="gameEditorToolbarState.h3 ? 'primary' : ''"
                          @click="applyGameEditorCommand('formatBlock', 'h3')"
                        >
                          H3
                        </v-btn>
                      </div>
                      <div class="editor-body">
                        <div
                          ref="gameDescriptionEditor"
                          class="editor-contenteditable"
                          contenteditable="true"
                          @input="onGameDescriptionInput"
                        ></div>
                      </div>
                    </div>

                    <v-expansion-panels class="mt-2" variant="accordion">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <v-icon start class="mr-2"
                            >mdi-book-open-page-variant</v-icon
                          >
                          Formázási segédlet
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <ul class="pl-4 text-caption">
                            <li><code>&lt;br&gt;</code> - Sortörés</li>
                            <li>
                              <code>&lt;b&gt;Szöveg&lt;/b&gt;</code> - Félkövér
                            </li>
                            <li>
                              <code>&lt;i&gt;Szöveg&lt;/i&gt;</code> - Dőlt
                            </li>
                            <li>
                              <code>&lt;u&gt;Szöveg&lt;/u&gt;</code> - Aláhúzott
                            </li>
                            <li>
                              <code>&lt;a href="url"&gt;Link&lt;/a&gt;</code> -
                              Hivatkozás
                            </li>
                            <li>
                              <code
                                >&lt;ul&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ul&gt;</code
                              >
                              - Lista
                            </li>
                            <li>
                              <code
                                >&lt;ol&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ol&gt;</code
                              >
                              - Számozott lista
                            </li>
                          </ul>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>

                  <!-- Játék időpontja -->
                  <v-col cols="12">
                    <v-text-field
                      label="Játék időpontja"
                      v-model="formattedGameDate"
                      prepend-inner-icon="mdi-calendar-clock"
                      outlined
                      dense
                      readonly
                      @focus="menuGameDatePicker = true"
                    ></v-text-field>
                    <v-menu
                      v-model="menuGameDatePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      :nudge-width="200"
                    >
                      <template #activator="{ props }">
                        <div v-bind="props"></div>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-date-picker v-model="tempGameDate" :min="today" />
                          <v-row dense class="mt-2">
                            <v-col cols="6">
                              <v-text-field
                                v-model="tempGameTime"
                                label="Óra:Perc"
                                type="time"
                                outlined
                                dense
                                required
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn @click="menuGameDatePicker = false"
                            >Bezárás</v-btn
                          >
                          <v-btn color="primary" @click="saveGameDateTime"
                            >Mentés</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>

                <!-- Pálya kiválasztás szakasz -->
                <v-divider class="my-4" />
                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      v-model="newGame.mapId"
                      :items="maps"
                      item-title="name"
                      item-value="id"
                      label="Válassz pályát"
                      outlined
                      dense
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="newGame.allowedGroupIds"
                      :items="availableEventGroups"
                      item-title="name"
                      item-value="id"
                      label="Engedélyezett csapatok"
                      prepend-inner-icon="mdi-account-multiple-check"
                      multiple
                      chips
                      closable-chips
                      clearable
                      outlined
                      dense
                      hint="Ha üresen hagyod, minden csapat láthatja a játékot."
                      persistent-hint
                    />
                  </v-col>
                </v-row>

                <!-- Jelentkezési határidő szakasz -->
                <v-divider class="my-4" />
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      label="Jelentkezési határidő"
                      v-model="formattedEndOfApplyDate"
                      prepend-inner-icon="mdi-calendar-clock"
                      outlined
                      dense
                      readonly
                      @focus="menuEndOfApplyPicker = true"
                    ></v-text-field>
                    <v-menu
                      v-model="menuEndOfApplyPicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      :nudge-width="200"
                    >
                      <template #activator="{ props }">
                        <div v-bind="props"></div>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-date-picker
                            v-model="tempEndOfApplyDate"
                            :min="today"
                            :max="formattedGameDate"
                          />

                          <v-row dense class="mt-2">
                            <v-col cols="6">
                              <v-text-field
                                v-model="tempEndOfApplyTime"
                                label="Óra:Perc"
                                type="time"
                                outlined
                                dense
                                required
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn @click="menuEndOfApplyPicker = false" text
                            >Bezárás</v-btn
                          >
                          <v-btn @click="saveEndOfApplyDate" color="primary"
                            >Mentés</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      label="Maximális résztvevők"
                      v-model="newGame.maxParticipants"
                      type="number"
                      outlined
                      dense
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox
                      v-model="newGame.sendNotificationEmails"
                      label="Értesítő e-mailek küldése"
                      dense
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn text @click="showGameDialog = false">Mégse</v-btn>
              <v-btn color="primary" @click="createGame">Létrehozás</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Pálya létrehozása dialog -->
        <v-dialog v-model="showMapDialog" max-width="900px">
          <v-card class="pa-6" elevation="10" rounded="lg">
            <v-card-title class="text-h5 font-weight-bold mb-4">
              Új pálya létrehozása
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="newMap.name"
                      label="Pálya neve"
                      prepend-inner-icon="mdi-map-marker"
                      outlined
                      dense
                      required
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="newMap.address"
                      label="Cím"
                      prepend-inner-icon="mdi-map"
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="12">
                    <div class="editor-shell mb-2">
                      <div class="editor-toolbar">
                        <v-btn
                          size="small"
                          :variant="
                            mapEditorToolbarState.bold ? 'flat' : 'text'
                          "
                          :color="mapEditorToolbarState.bold ? 'primary' : ''"
                          icon="mdi-format-bold"
                          @click="applyMapEditorCommand('bold')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            mapEditorToolbarState.italic ? 'flat' : 'text'
                          "
                          :color="mapEditorToolbarState.italic ? 'primary' : ''"
                          icon="mdi-format-italic"
                          @click="applyMapEditorCommand('italic')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            mapEditorToolbarState.underline ? 'flat' : 'text'
                          "
                          :color="
                            mapEditorToolbarState.underline ? 'primary' : ''
                          "
                          icon="mdi-format-underline"
                          @click="applyMapEditorCommand('underline')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            mapEditorToolbarState.unorderedList
                              ? 'flat'
                              : 'text'
                          "
                          :color="
                            mapEditorToolbarState.unorderedList ? 'primary' : ''
                          "
                          icon="mdi-format-list-bulleted"
                          @click="applyMapEditorCommand('insertUnorderedList')"
                        />
                        <v-btn
                          size="small"
                          :variant="
                            mapEditorToolbarState.orderedList ? 'flat' : 'text'
                          "
                          :color="
                            mapEditorToolbarState.orderedList ? 'primary' : ''
                          "
                          icon="mdi-format-list-numbered"
                          @click="applyMapEditorCommand('insertOrderedList')"
                        />
                        <v-btn
                          size="small"
                          :variant="mapEditorToolbarState.h2 ? 'flat' : 'text'"
                          :color="mapEditorToolbarState.h2 ? 'primary' : ''"
                          @click="applyMapEditorCommand('formatBlock', 'h2')"
                        >
                          H2
                        </v-btn>
                        <v-btn
                          size="small"
                          :variant="mapEditorToolbarState.h3 ? 'flat' : 'text'"
                          :color="mapEditorToolbarState.h3 ? 'primary' : ''"
                          @click="applyMapEditorCommand('formatBlock', 'h3')"
                        >
                          H3
                        </v-btn>
                      </div>
                      <div class="editor-body">
                        <div
                          ref="mapDescriptionEditor"
                          class="editor-contenteditable"
                          contenteditable="true"
                          @input="onMapDescriptionInput"
                        ></div>
                      </div>
                    </div>
                    <v-expansion-panels class="mt-4" variant="accordion">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <v-icon start class="mr-2"
                            >mdi-book-open-page-variant</v-icon
                          >
                          Formázási segédlet
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <ul class="pl-4 text-caption">
                            <li><code>&lt;br&gt;</code> - Sortörés</li>
                            <li>
                              <code>&lt;b&gt;Szöveg&lt;/b&gt;</code> - Félkövér
                            </li>
                            <li>
                              <code>&lt;i&gt;Szöveg&lt;/i&gt;</code> - Dőlt
                            </li>
                            <li>
                              <code>&lt;u&gt;Szöveg&lt;/u&gt;</code> - Aláhúzott
                            </li>
                            <li>
                              <code>&lt;a href="url"&gt;Link&lt;/a&gt;</code> -
                              Hivatkozás
                            </li>
                            <li>
                              <code
                                >&lt;ul&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ul&gt;</code
                              >
                              - Lista
                            </li>
                            <li>
                              <code
                                >&lt;ol&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ol&gt;</code
                              >
                              - Számozott lista
                            </li>
                          </ul>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="newMap.imageUrl"
                      label="Pálya képe URL (opcionális)"
                      prepend-inner-icon="mdi-image"
                      outlined
                      dense
                      :disabled="selectedMapImage !== null"
                    />
                    <div class="d-flex align-center ga-2 flex-wrap">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-upload"
                        :disabled="isMapSubmitting"
                        @click="mapImageInput?.click()"
                      >
                        Pályakép feltöltése
                      </v-btn>
                      <span class="text-caption text-medium-emphasis">
                        {{
                          selectedMapImage
                            ? selectedMapImage.name
                            : "Nincs fájl kiválasztva"
                        }}
                      </span>
                      <v-btn
                        v-if="selectedMapImage"
                        size="small"
                        variant="text"
                        color="error"
                        @click="removeSelectedMapImage"
                      >
                        Törlés
                      </v-btn>
                    </div>

                    <div v-if="isMapSubmitting" class="mt-3">
                      <v-progress-linear
                        :model-value="mapUploadProgress"
                        :indeterminate="mapUploadProgress <= 0"
                        color="primary"
                      />
                      <div class="text-caption text-medium-emphasis mt-1">
                        Feltöltés folyamatban...
                        {{
                          mapUploadProgress > 0 ? `${mapUploadProgress}%` : ""
                        }}
                      </div>
                    </div>

                    <div
                      v-if="mapImagePreview"
                      class="mt-3 map-image-preview-wrap"
                    >
                      <img
                        :src="mapImagePreview"
                        alt="Pályakép előnézet"
                        class="map-image-preview"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <input
                      ref="mapImageInput"
                      type="file"
                      accept="image/*"
                      style="display: none"
                      @change="onMapImageSelect"
                    />
                    <div class="d-flex align-center ga-2 flex-wrap">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-upload"
                        :disabled="isMapSubmitting"
                        @click="mapImageInput?.click()"
                      >
                        Pályakép feltöltése
                      </v-btn>
                      <span class="text-caption text-medium-emphasis">
                        {{
                          selectedMapImage
                            ? selectedMapImage.name
                            : "Nincs fájl kiválasztva"
                        }}
                      </span>
                      <v-btn
                        v-if="selectedMapImage"
                        size="small"
                        variant="text"
                        color="error"
                        @click="removeSelectedMapImage"
                      >
                        Törlés
                      </v-btn>
                    </div>

                    <div v-if="isMapSubmitting" class="mt-3">
                      <v-progress-linear
                        :model-value="mapUploadProgress"
                        :indeterminate="mapUploadProgress <= 0"
                        color="primary"
                      />
                      <div class="text-caption text-medium-emphasis mt-1">
                        Feltöltés folyamatban...
                        {{
                          mapUploadProgress > 0 ? `${mapUploadProgress}%` : ""
                        }}
                      </div>
                    </div>

                    <div
                      v-if="mapImagePreview"
                      class="mt-3 map-image-preview-wrap"
                    >
                      <img
                        :src="mapImagePreview"
                        alt="Pályakép előnézet"
                        class="map-image-preview"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider class="my-4" />

            <v-card-actions>
              <v-spacer />
              <v-btn variant="text" color="grey" @click="showMapDialog = false">
                Mégse
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                :loading="isMapSubmitting"
                :disabled="isMapSubmitting"
                @click="createMap"
              >
                Létrehozás
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Blog bejegyzés létrehozása -->
        <!-- Blog post dialog (replace your dialog block with this) -->
        <v-dialog v-model="showPostDialog" max-width="900px" persistent>
          <v-card class="elevation-10 rounded-lg">
            <v-card-title class="text-h5 font-weight-bold bg-primary pa-4">
              <v-icon left>mdi-post-outline</v-icon> Új Blogbejegyzés
              Létrehozása
            </v-card-title>

            <v-card-text class="pt-4">
              <div v-if="isBlogPostSubmitting" class="mb-4">
                <v-alert type="info" variant="tonal">
                  {{
                    selectedPostImages.length > 0
                      ? "Képek feltöltése és bejegyzés mentése folyamatban..."
                      : "Bejegyzés mentése folyamatban..."
                  }}
                </v-alert>
                <v-progress-linear
                  :model-value="blogUploadProgress"
                  :indeterminate="blogUploadProgress <= 0"
                  color="primary"
                />
                <div
                  v-if="blogUploadProgress > 0"
                  class="text-caption text-medium-emphasis mt-1"
                >
                  Feltöltési állapot: {{ blogUploadProgress }}%
                </div>
              </div>
              <v-form ref="postForm">
                <!-- Cím -->
                <v-text-field
                  v-model="newPost.title"
                  label="Bejegyzés címe"
                  prepend-inner-icon="mdi-format-title"
                  variant="outlined"
                  required
                  class="mb-4"
                />

                <!-- Toolbar + Textarea + Preview toggle -->
                <div class="editor-shell mb-4">
                  <v-expansion-panels class="mt-4" variant="accordion">
                    <v-expansion-panel>
                      <v-expansion-panel-title>
                        <v-icon start class="mr-2"
                          >mdi-book-open-page-variant</v-icon
                        >
                        Formázási segédlet
                      </v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <ul class="pl-4 text-caption">
                          <li><code>&lt;br&gt;</code> - Sortörés</li>
                          <li>
                            <code>&lt;b&gt;Szöveg&lt;/b&gt;</code> - Félkövér
                          </li>
                          <li><code>&lt;i&gt;Szöveg&lt;/i&gt;</code> - Dőlt</li>
                          <li>
                            <code>&lt;u&gt;Szöveg&lt;/u&gt;</code> - Aláhúzott
                          </li>
                          <li>
                            <code>&lt;a href="url"&gt;Link&lt;/a&gt;</code> -
                            Hivatkozás
                          </li>
                          <li>
                            <code
                              >&lt;ul&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ul&gt;</code
                            >
                            - Lista
                          </li>
                          <li>
                            <code
                              >&lt;ol&gt;&lt;li&gt;Elem&lt;/li&gt;&lt;/ol&gt;</code
                            >
                            - Számozott lista
                          </li>
                          <li>
                            <code>&lt;strong&gt;Szöveg&lt;/strong&gt;</code> -
                            Erősen kiemelt
                          </li>
                          <li>
                            <code>&lt;em&gt;Szöveg&lt;/em&gt;</code> -
                            Hangsúlyozott
                          </li>
                        </ul>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <div class="editor-toolbar">
                    <v-btn
                      size="small"
                      :variant="postEditorToolbarState.bold ? 'flat' : 'text'"
                      :color="postEditorToolbarState.bold ? 'primary' : ''"
                      icon="mdi-format-bold"
                      @click="applyEditorCommand('bold')"
                    />
                    <v-btn
                      size="small"
                      :variant="postEditorToolbarState.italic ? 'flat' : 'text'"
                      :color="postEditorToolbarState.italic ? 'primary' : ''"
                      icon="mdi-format-italic"
                      @click="applyEditorCommand('italic')"
                    />
                    <v-btn
                      size="small"
                      :variant="
                        postEditorToolbarState.underline ? 'flat' : 'text'
                      "
                      :color="postEditorToolbarState.underline ? 'primary' : ''"
                      icon="mdi-format-underline"
                      @click="applyEditorCommand('underline')"
                    />
                    <v-btn
                      size="small"
                      :variant="
                        postEditorToolbarState.unorderedList ? 'flat' : 'text'
                      "
                      :color="
                        postEditorToolbarState.unorderedList ? 'primary' : ''
                      "
                      icon="mdi-format-list-bulleted"
                      @click="applyEditorCommand('insertUnorderedList')"
                    />
                    <v-btn
                      size="small"
                      :variant="
                        postEditorToolbarState.orderedList ? 'flat' : 'text'
                      "
                      :color="
                        postEditorToolbarState.orderedList ? 'primary' : ''
                      "
                      icon="mdi-format-list-numbered"
                      @click="applyEditorCommand('insertOrderedList')"
                    />
                    <v-btn
                      size="small"
                      :variant="postEditorToolbarState.h2 ? 'flat' : 'text'"
                      :color="postEditorToolbarState.h2 ? 'primary' : ''"
                      @click="applyEditorCommand('formatBlock', 'h2')"
                    >
                      H2
                    </v-btn>
                    <v-btn
                      size="small"
                      :variant="postEditorToolbarState.h3 ? 'flat' : 'text'"
                      :color="postEditorToolbarState.h3 ? 'primary' : ''"
                      @click="applyEditorCommand('formatBlock', 'h3')"
                    >
                      H3
                    </v-btn>
                    <v-btn
                      size="small"
                      icon="mdi-link-variant"
                      @click="applyEditorCommand('createLink')"
                    />
                  </div>

                  <div class="editor-body">
                    <div
                      ref="postContentEditor"
                      class="editor-contenteditable"
                      contenteditable="true"
                      @input="onEditorInput"
                      @paste="onPostEditorPaste"
                    ></div>
                  </div>
                </div>

                <!-- Borítókép URL + több kép feltöltés -->
                <v-row class="mb-4" dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="newPost.imageUrl"
                      label="Címlapkép URL-je (opcionális)"
                      prepend-inner-icon="mdi-image-edit-outline"
                      variant="outlined"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <input
                      id="imgUpload"
                      ref="postImagesInput"
                      type="file"
                      accept="image/*"
                      multiple
                      @change="onImageSelect"
                      style="display: none"
                    />

                    <div class="d-flex align-center ga-2">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-upload"
                        :disabled="isBlogPostSubmitting"
                        @click="postImagesInput?.click()"
                      >
                        Képek feltöltése
                      </v-btn>
                      <span class="text-caption text-grey">
                        {{ selectedPostImages.length }} fájl kiválasztva
                      </span>
                    </div>
                    <div v-if="isBlogPostSubmitting" class="mt-2">
                      <div class="text-caption text-medium-emphasis mt-1">
                        {{
                          selectedPostImages.length > 0
                            ? "Képfeltöltés folyamatban... kérlek várj."
                            : "Mentés folyamatban... kérlek várj."
                        }}
                      </div>
                    </div>

                    <div v-if="imagePreviews.length" class="image-gallery mt-3">
                      <div
                        v-for="(image, index) in imagePreviews"
                        :key="`${image}-${index}`"
                        class="image-thumb-wrap"
                      >
                        <img
                          :src="image"
                          alt="preview"
                          class="image-thumb"
                          @click="openPreviewImage(image)"
                          :class="{
                            'image-thumb--cover':
                              selectedCoverImageIndex === index,
                          }"
                        />
                        <div class="image-caption">
                          {{
                            selectedCoverImageIndex === index
                              ? "Borítókép"
                              : "Feltöltött kép"
                          }}
                        </div>
                        <div class="image-thumb-actions">
                          <div class="image-config-row">
                            <label class="image-config-label">Méret</label>
                            <input
                              type="number"
                              min="20"
                              max="90"
                              class="image-config-input"
                              :value="getImageInsertOption(index).width"
                              @input="setImageWidthFromEvent(index, $event)"
                            />
                            <span class="image-config-unit">%</span>
                          </div>
                          <div class="image-align-row">
                            <v-btn
                              size="x-small"
                              :variant="
                                getImageInsertOption(index).align === 'left'
                                  ? 'flat'
                                  : 'outlined'
                              "
                              @click="setImageAlign(index, 'left')"
                            >
                              Bal
                            </v-btn>
                            <v-btn
                              size="x-small"
                              :variant="
                                getImageInsertOption(index).align === 'center'
                                  ? 'flat'
                                  : 'outlined'
                              "
                              @click="setImageAlign(index, 'center')"
                            >
                              Közép
                            </v-btn>
                            <v-btn
                              size="x-small"
                              :variant="
                                getImageInsertOption(index).align === 'right'
                                  ? 'flat'
                                  : 'outlined'
                              "
                              @click="setImageAlign(index, 'right')"
                            >
                              Jobb
                            </v-btn>
                          </div>
                          <v-btn
                            size="small"
                            :variant="
                              selectedCoverImageIndex === index
                                ? 'flat'
                                : 'outlined'
                            "
                            color="primary"
                            class="image-action-btn"
                            @click="setCoverImageIndex(index)"
                          >
                            {{
                              selectedCoverImageIndex === index
                                ? "Borítókép"
                                : "Borítónak"
                            }}
                          </v-btn>
                          <v-btn
                            size="small"
                            variant="flat"
                            color="deep-orange"
                            class="image-action-btn"
                            @click="insertImageToEditor(index)"
                          >
                            Beszúrás
                          </v-btn>
                        </div>
                        <v-btn
                          size="x-small"
                          icon="mdi-close"
                          color="error"
                          class="image-remove-btn"
                          @click="removeSelectedImage(index)"
                        />
                      </div>
                    </div>
                    <div
                      v-if="imagePreviews.length"
                      class="text-caption text-medium-emphasis mt-2"
                    >
                      Tipp: állítsd be a kép méretét/pozícióját a kártyán, majd
                      nyomj `Beszúrás`-t.
                    </div>
                  </v-col>
                </v-row>

                <!-- Kategóriák (combobox több választással, új kategória hozzáadható) -->
                <v-combobox
                  v-model="newPost.categories"
                  :items="availableCategories"
                  label="Kategóriák"
                  multiple
                  chips
                  clearable
                  allow-new
                  prepend-inner-icon="mdi-tag-multiple-outline"
                  variant="outlined"
                  hint="Több kategória is választható vagy létrehozható"
                  persistent-hint
                  @update:modelValue="onCategoriesUpdate"
                />
                <div class="d-flex justify-end mt-2">
                  <v-btn
                    size="small"
                    variant="text"
                    prepend-icon="mdi-tag-remove"
                    :disabled="!blogCategories.length"
                    @click="showCategoryManagerDialog = true"
                  >
                    Kategóriák kezelése
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>

            <v-divider class="mt-4" />

            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn text :disabled="isBlogPostSubmitting" @click="onCancel"
                >Mégse</v-btn
              >
              <v-btn
                variant="outlined"
                color="grey"
                @click="createPost('draft')"
                :disabled="isBlogPostSubmitting"
                :loading="isBlogPostSubmitting"
              >
                Mentés piszkozatként
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="createPost('published')"
                :disabled="
                  !newPost.title || !newPost.content || isBlogPostSubmitting
                "
                :loading="isBlogPostSubmitting"
              >
                Publikálás
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showCategoryManagerDialog" max-width="560">
          <v-card>
            <v-card-title>Kategóriák kezelése</v-card-title>
            <v-card-text>
              <div v-if="!blogCategories.length" class="text-medium-emphasis">
                Nincs törölhető kategória.
              </div>
              <div v-else class="d-flex flex-column ga-2">
                <div
                  v-for="category in blogCategories"
                  :key="category.id"
                  class="d-flex justify-space-between align-center"
                >
                  <v-chip color="primary" variant="tonal">
                    {{ category.name }}
                  </v-chip>
                  <v-btn
                    icon="mdi-delete"
                    size="small"
                    color="error"
                    variant="text"
                    :disabled="isCategoryDeleting"
                    @click="deleteBlogCategory(category)"
                  />
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn variant="text" @click="showCategoryManagerDialog = false">
                Bezárás
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <router-view />

        <v-alert
          v-for="(error, index) in alert.text"
          :key="index"
          border="end"
          border-color="error"
          elevation="2"
          :dismissible="true"
          :autoDismiss="true"
          :dismissTimeout="5000"
        >
          {{ error }}
        </v-alert>

        <AppSnackbar
          v-model="snackbar.showing"
          :color="snackbar.color"
          :title="snackbar.title"
          :text="snackbar.text"
          :icon="snackbar.icon"
          :timeout="snackbar.timeout"
        />
        <AppConfirmDialog
          v-model="confirmDialog.showing"
          :title="confirmDialog.title"
          :text="confirmDialog.text"
          :confirm-text="confirmDialog.confirmText"
          :cancel-text="confirmDialog.cancelText"
          :color="confirmDialog.color"
          :icon="confirmDialog.icon"
          @confirm="store.dispatch('resolveConfirmDialog', true)"
          @cancel="store.dispatch('resolveConfirmDialog', false)"
        />
      </v-container>
    </v-main>

    <v-bottom-navigation
      v-if="profile?.username"
      class="d-md-none mobile-bottom-nav"
      bg-color="surface"
      grow
      elevation="8"
    >
      <v-btn
        :active="isRouteActive(['forum-page', 'blog-post-page', 'BlogEdit'])"
        @click="router.push({ name: 'forum-page' })"
      >
        <v-icon>mdi-post-outline</v-icon>
        Blog
      </v-btn>
      <v-btn
        :active="isRouteActive(['games-page', 'games-page-legacy-detail'])"
        @click="router.push({ name: 'games-page' })"
      >
        <v-icon>mdi-gamepad-variant-outline</v-icon>
        Játékok
      </v-btn>
      <v-btn
        :active="isRouteActive(['maps-page'])"
        @click="router.push({ name: 'maps-page' })"
      >
        <v-icon>mdi-map-marker-outline</v-icon>
        Pályák
      </v-btn>
      <v-btn :active="isRouteActive(['profile-page'])" @click="goToProfile">
        <v-icon>mdi-account-circle-outline</v-icon>
        Profil
      </v-btn>
      <v-btn :active="drawer" @click="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
        Menü
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script lang="ts" setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { useTheme } from "vuetify";
import api from "@/api";
import AppSnackbar from "@/views/components/AppSnackbar.vue";
import AppConfirmDialog from "@/views/components/AppConfirmDialog.vue";
import {
  FrontendStudioSettings,
  applyFrontendStudioCssVars,
  loadFrontendStudioSettings,
} from "@/utils/frontendStudio";

// Router & Store
const router = useRouter();
const route = useRoute();
const store = useStore();

// Vuetify Theme
const theme = useTheme();
const themeIcon = ref("");

// App State
const activeTab = ref<string | number | null>(null);
const drawer = ref(false);
const isProfileActive = ref(false);

// Dialogs
const showGameDialog = ref(false);
const showMapDialog = ref(false);
const menuEndOfApplyPicker = ref(false);
const menuGameDatePicker = ref(false);
// HOZZÁADVA: Blogbejegyzés dialógus
const showPostDialog = ref(false);
const showCategoryManagerDialog = ref(false);
const postImagesInput = ref<HTMLInputElement | null>(null);
const mapImageInput = ref<HTMLInputElement | null>(null);
const gameDescriptionEditor = ref<HTMLDivElement | null>(null);
const mapDescriptionEditor = ref<HTMLDivElement | null>(null);
type EditorToolbarState = {
  bold: boolean;
  italic: boolean;
  underline: boolean;
  unorderedList: boolean;
  orderedList: boolean;
  h2: boolean;
  h3: boolean;
};

const createDefaultToolbarState = (): EditorToolbarState => ({
  bold: false,
  italic: false,
  underline: false,
  unorderedList: false,
  orderedList: false,
  h2: false,
  h3: false,
});

const gameEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
const mapEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
const availableEventGroups = ref<Array<{ id: number; name: string }>>([]);

// New Game & Map State
const today = new Date().toISOString().substr(0, 10);
const tempEndOfApplyDate = ref<string | null>(null);
const tempEndOfApplyTime = ref<string | null>(null);

const tempGameDate = ref<string | null>(null);
const tempGameTime = ref<string | null>(null);

const newGame = ref({
  name: "",
  description: "",
  date: "",
  mapId: null as string | null,
  endOfApply: "",
  maxParticipants: 0,
  allowedGroupIds: [] as number[],
  sendNotificationEmails: true, // Új mező, alapértelmezett érték true
});

const newMap = ref({
  name: "",
  description: "",
  address: "",
  contactPage: "",
  imageUrl: "",
});

const selectedMapImage = ref<File | null>(null);
const mapImagePreview = ref("");
const isMapSubmitting = ref(false);
const mapUploadProgress = ref(0);

// Bejegyzés modell
const newPost = ref({
  title: "",
  content: "",
  imageUrl: "",
  categories: [] as string[],
});

// Kategóriák
const blogCategories = ref<Array<{ id: number; name: string }>>([]);
const isCategoryDeleting = ref(false);
const availableCategories = ref<string[]>([
  "Hírek",
  "Események",
  "Fejlesztés",
  "Élmény beszámoló",
  "Privát játék",
  "Publikus játék",
]);

// Computed State
const alert = computed(() => store.state.alert);
const snackbar = computed(() => store.state.snackbar);
const confirmDialog = computed(() => store.state.confirmDialog);
const profile = computed(() => store.state.profile);
const maps = computed(() => store.state.maps);
const canViewStatistics = ref(false);
const studioSettings = ref<FrontendStudioSettings>(
  loadFrontendStudioSettings()
);

function reloadFrontendStudioSettings() {
  const loaded = loadFrontendStudioSettings();
  studioSettings.value = loaded;
  applyFrontendStudioCssVars(loaded);
}

const formattedEndOfApplyDate = computed(() => {
  if (!newGame.value.endOfApply) return "";
  const d = new Date(newGame.value.endOfApply);
  return d.toLocaleString("hu-HU", {
    timeZone: "Europe/Budapest",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
});

const formattedGameDate = computed(() => {
  if (!newGame.value.date) return "";
  const d = new Date(newGame.value.date);
  return d.toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
  });
});

// Methods
function toggleTheme() {
  theme.global.name.value = theme.global.current.value.dark ? "light" : "dark";
  themeIcon.value =
    theme.global.name.value === "dark"
      ? "mdi-weather-sunny"
      : "mdi-weather-night";
  localStorage.setItem("currentTheme", theme.global.name.value);
}

async function logoutUser() {
  try {
    const request = await store.dispatch("deleteProfileData");
    store.commit("SET_PROFILE", null);
    activeTab.value = 0;
    router.push({ name: "forum-page" });
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: request.responseData.responseMessage,
      color: "success",
    });
  } catch {
    store.commit("SET_PROFILE", null);
    activeTab.value = 0;
    router.push({ name: "login-page" });
  }
}

function goToProfile() {
  isProfileActive.value = true;
  activeTab.value = null;
  router.push({ name: "profile-page" });
}

function resetProfileActive() {
  isProfileActive.value = false;
}

function isRouteActive(routeNames: string[]) {
  return routeNames.includes(String(route.name || ""));
}

async function openGameDialog(closeDrawer = false) {
  if (!Array.isArray(maps.value) || maps.value.length === 0) {
    try {
      await store.dispatch("fetchMaps");
    } catch (error) {
      console.error("Pályák előtöltése sikertelen:", error);
    }
  }

  if (availableEventGroups.value.length === 0) {
    try {
      const groups = await store.dispatch("getGroups");
      availableEventGroups.value = Array.isArray(groups)
        ? groups.map((group: any) => ({
            id: Number(group.id),
            name: String(group.name || ""),
          }))
        : [];
    } catch (error) {
      console.error("Csapatok előtöltése sikertelen:", error);
    }
  }

  showGameDialog.value = true;
  if (closeDrawer) {
    drawer.value = false;
  }
}

function saveGameDateTime() {
  if (!tempGameDate.value || tempGameTime.value === null) {
    store.dispatch("setAlert", {
      error: "Kérlek, add meg a játék dátumát, óráját és percét is!",
    });
    return;
  }

  try {
    // A tempEndOfApplyDate.value stringként érkezik pl. '2025-04-29', ezért új Date objektumot csinálunk
    const dateObj = new Date(tempGameDate.value);
    if (isNaN(dateObj.getTime())) {
      throw new Error("Érvénytelen dátum formátum.");
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const time = tempGameTime.value;

    // Mentés az új formátumban (YYYY-MM-DD HH:mm) - JAVÍTVA
    newGame.value.date = `${year}. ${month}. ${day}. ${time}`;
    menuGameDatePicker.value = false;
  } catch (error) {
    console.error("Hiba a dátum feldolgozása közben:", error);
    store.dispatch("setAlert", {
      error: "Hiba történt a dátum formázása közben.",
    });
  }
}

function saveEndOfApplyDate() {
  if (!tempEndOfApplyDate.value || tempEndOfApplyTime.value === null) {
    store.dispatch("setAlert", {
      error:
        "Kérlek, add meg a jelentkezési határidő dátumát, óráját és percét is!",
    });
    return;
  }

  try {
    // A tempEndOfApplyDate.value stringként érkezik pl. '2025-04-29', ezért új Date objektumot csinálunk
    const dateObj = tempEndOfApplyDate.value; // Ez egy Date objektum
    const timeObj = tempEndOfApplyTime.value; // Pl.: "15:15"

    if (isNaN(dateObj.getTime())) {
      throw new Error("Érvénytelen dátum formátum.");
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const dateTime = `${year}.${month}.${day} ${timeObj}`; // ISO 8601

    // // Mentés az új formátumban (YYYY-MM-DD HH:mm)
    newGame.value.endOfApply = dateTime;
    menuEndOfApplyPicker.value = false;
  } catch (error) {
    console.error("Hiba a dátum feldolgozása közben:", error);
    store.dispatch("setAlert", {
      error: "Hiba történt a dátum formázása közben.",
    });
  }
}

function queryCommandStateSafe(command: string): boolean {
  try {
    return document.queryCommandState(command);
  } catch {
    return false;
  }
}

function getActiveBlockTag(editor: HTMLDivElement | null): string {
  if (!editor) return "";
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return "";
  const anchor = selection.anchorNode;
  if (!anchor || !editor.contains(anchor)) return "";

  let current: HTMLElement | null =
    anchor.nodeType === Node.TEXT_NODE
      ? anchor.parentElement
      : (anchor as HTMLElement);

  while (current && editor.contains(current)) {
    const tag = current.tagName?.toLowerCase();
    if (tag === "h2" || tag === "h3") return tag;
    current = current.parentElement;
  }
  return "";
}

function refreshEditorToolbarState(
  editor: HTMLDivElement | null,
  target: { value: EditorToolbarState }
) {
  if (!editor) {
    target.value = createDefaultToolbarState();
    return;
  }

  const selection = window.getSelection();
  const anchor = selection?.anchorNode;
  const inEditor = Boolean(anchor && editor.contains(anchor));
  if (!inEditor) {
    target.value = createDefaultToolbarState();
    return;
  }

  const block = getActiveBlockTag(editor);
  target.value = {
    bold: queryCommandStateSafe("bold"),
    italic: queryCommandStateSafe("italic"),
    underline: queryCommandStateSafe("underline"),
    unorderedList: queryCommandStateSafe("insertUnorderedList"),
    orderedList: queryCommandStateSafe("insertOrderedList"),
    h2: block === "h2",
    h3: block === "h3",
  };
}

const onEditorSelectionChange = () => {
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
};

function syncGameDescriptionToModel() {
  newGame.value.description = gameDescriptionEditor.value?.innerHTML || "";
}

function onGameDescriptionInput() {
  syncGameDescriptionToModel();
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
}

function applyGameEditorCommand(command: string, value?: string) {
  const editor = gameDescriptionEditor.value;
  if (!editor) return;
  editor.focus();
  document.execCommand(command, false, value);
  syncGameDescriptionToModel();
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
}

function syncMapDescriptionToModel() {
  newMap.value.description = mapDescriptionEditor.value?.innerHTML || "";
}

function onMapDescriptionInput() {
  syncMapDescriptionToModel();
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
}

function applyMapEditorCommand(command: string, value?: string) {
  const editor = mapDescriptionEditor.value;
  if (!editor) return;
  editor.focus();
  document.execCommand(command, false, value);
  syncMapDescriptionToModel();
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
}

async function createGame() {
  syncGameDescriptionToModel();
  try {
    const safeName = String(newGame.value.name || "").trim();
    const safeDescription = String(newGame.value.description || "").trim();
    const safeDate = String(newGame.value.date || "").trim();
    const safeEndOfApply = String(newGame.value.endOfApply || "").trim();
    const safeMapId = String(newGame.value.mapId || "").trim();
    const safeMaxParticipants = Number(newGame.value.maxParticipants || 0);
    const safeAllowedGroupIds = Array.from(
      new Set(
        (Array.isArray(newGame.value.allowedGroupIds)
          ? newGame.value.allowedGroupIds
          : []
        )
          .map((value) => Number(value))
          .filter((value) => Number.isInteger(value) && value > 0)
      )
    );

    if (!safeName || safeName.length < 3) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A játék nevének legalább 3 karakteresnek kell lennie.",
        color: "error",
      });
      return;
    }
    if (!safeDescription) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A játék leírása kötelező.",
        color: "error",
      });
      return;
    }
    if (!safeDate || !safeEndOfApply || !safeMapId) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "Időpont, jelentkezési határidő és pálya kiválasztása kötelező.",
        color: "error",
      });
      return;
    }
    if (!Number.isFinite(safeMaxParticipants) || safeMaxParticipants < 2) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A maximális résztvevőszám minimum 2 fő.",
        color: "error",
      });
      return;
    }

    const payload = {
      name: safeName,
      description: safeDescription,
      date: safeDate,
      mapId: safeMapId,
      endOfApply: safeEndOfApply,
      maxParticipants: Math.round(safeMaxParticipants),
      allowedGroupIds: safeAllowedGroupIds,
      sendNotificationEmails: Boolean(newGame.value.sendNotificationEmails),
    };

    const response = await store.dispatch("addEvent", payload);
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: response,
      color: "success",
    });
    showGameDialog.value = false;
    newGame.value = {
      name: "",
      description: "",
      date: "",
      mapId: null,
      endOfApply: "",
      maxParticipants: 0,
      allowedGroupIds: [],
      sendNotificationEmails: true,
    };
    if (gameDescriptionEditor.value) {
      gameDescriptionEditor.value.innerHTML = "";
    }
    store.dispatch("fetchEvents");
  } catch (error: any) {
    console.error("Hiba pálya létrehozásakor:", error.message);
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text: error.message || "Nem sikerült létrehozni a pályát.",
      color: "error",
    });
  }
}

async function createMap() {
  syncMapDescriptionToModel();
  isMapSubmitting.value = true;
  mapUploadProgress.value = 0;
  try {
    const safeName = String(newMap.value.name || "").trim();
    const safeAddress = String(newMap.value.address || "").trim();
    const safeDescription = String(newMap.value.description || "").trim();
    const safeContactPage = String(newMap.value.contactPage || "").trim();
    const safeImageUrl = String(newMap.value.imageUrl || "").trim();
    const hasValidImageUrl =
      safeImageUrl.length > 0
        ? /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(safeImageUrl)
        : false;

    if (!safeName || safeName.length < 2) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya neve kötelező (minimum 2 karakter).",
        color: "error",
      });
      return;
    }
    if (!safeAddress) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya címe kötelező.",
        color: "error",
      });
      return;
    }
    if (!safeDescription) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya leírása kötelező.",
        color: "error",
      });
      return;
    }
    if (
      safeContactPage &&
      !/^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(safeContactPage)
    ) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A kapcsolat linkje csak érvényes http/https URL lehet.",
        color: "error",
      });
      return;
    }
    if (!selectedMapImage.value && safeImageUrl && !hasValidImageUrl) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A kép URL formátuma érvénytelen.",
        color: "error",
      });
      return;
    }

    const payload = new FormData();
    payload.append("name", safeName);
    payload.append("address", safeAddress);
    payload.append("description", safeDescription);
    payload.append("contactPage", safeContactPage);

    if (selectedMapImage.value) {
      payload.append("image", selectedMapImage.value);
    } else if (safeImageUrl) {
      payload.append("imageUrl", safeImageUrl);
    }

    await api.post("/maps/new", payload, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const total = Number(event?.total || 0);
        const loaded = Number(event?.loaded || 0);
        if (total > 0) {
          mapUploadProgress.value = Math.min(
            100,
            Math.max(1, Math.round((loaded / total) * 100))
          );
        } else {
          mapUploadProgress.value = 0;
        }
      },
    });

    store.dispatch("setSnackbar", {
      title: "Pálya létrehozva",
      text: "Sikeres pálya létrehozás!",
      color: "success",
    });
    showMapDialog.value = false;
    resetMapForm();
    store.dispatch("fetchMaps");
  } catch (error: any) {
    console.error("Hiba pálya létrehozásakor:", error.message);
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text: error.message || "Nem sikerült létrehozni a pályát.",
      color: "error",
    });
  } finally {
    isMapSubmitting.value = false;
    mapUploadProgress.value = 0;
  }
}

async function onMapImageSelect(event: Event) {
  const input = event.target as HTMLInputElement | null;
  if (!input?.files || input.files.length === 0) return;

  const file = input.files[0];
  const optimizedFile = await resizeImageFile(file);
  selectedMapImage.value = optimizedFile;
  if (mapImagePreview.value) {
    URL.revokeObjectURL(mapImagePreview.value);
  }
  mapImagePreview.value = URL.createObjectURL(optimizedFile);
  newMap.value.imageUrl = "";
  input.value = "";
}

function removeSelectedMapImage() {
  selectedMapImage.value = null;
  if (mapImagePreview.value) {
    URL.revokeObjectURL(mapImagePreview.value);
  }
  mapImagePreview.value = "";
}

function resetMapForm() {
  newMap.value = {
    name: "",
    description: "",
    address: "",
    contactPage: "",
    imageUrl: "",
  };
  if (mapDescriptionEditor.value) {
    mapDescriptionEditor.value.innerHTML = "";
  }
  mapEditorToolbarState.value = createDefaultToolbarState();
  removeSelectedMapImage();
}

const postContentEditor = ref<HTMLDivElement | null>(null);
const postEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
type ImageAlign = "left" | "center" | "right";
type ImageInsertOption = { width: number; align: ImageAlign };

const imagePreviews = ref<string[]>([]);
const selectedPostImages = ref<File[]>([]);
const imagePreviewUrlByFile = new WeakMap<File, string>();
const selectedCoverImageIndex = ref<number | null>(null);
const imageInsertOptions = ref<Record<number, ImageInsertOption>>({});
const isBlogPostSubmitting = ref(false);
const blogUploadProgress = ref(0);
const MAX_UPLOAD_IMAGE_EDGE = 1920;
const IMAGE_UPLOAD_QUALITY = 0.82;
const BLOG_IMAGE_MAX_COUNT = 30;

function getImageInsertOption(index: number): ImageInsertOption {
  const existing = imageInsertOptions.value[index];
  if (existing) return existing;
  const def: ImageInsertOption = { width: 45, align: "center" };
  imageInsertOptions.value[index] = def;
  return def;
}

function setImageAlign(index: number, align: ImageAlign) {
  const current = getImageInsertOption(index);
  imageInsertOptions.value[index] = { ...current, align };
}

function setImageWidth(index: number, width: number) {
  const current = getImageInsertOption(index);
  const safe = Math.min(90, Math.max(20, Number.isFinite(width) ? width : 45));
  imageInsertOptions.value[index] = { ...current, width: Math.round(safe) };
}

function setImageWidthFromEvent(index: number, event: Event) {
  const target = event.target as HTMLInputElement | null;
  if (!target) return;
  setImageWidth(index, Number(target.value));
}

function buildImageInsertStyle(width: number, align: ImageAlign) {
  const alignStyle =
    align === "left"
      ? "display:block;margin:16px auto 16px 0;"
      : align === "right"
      ? "display:block;margin:16px 0 16px auto;"
      : "display:block;margin:16px auto;";
  return `width:${width}%;max-width:100%;height:auto;object-fit:contain;border-radius:12px;${alignStyle}`;
}

function resolveImageInsertOptionFromNode(
  imgNode: HTMLImageElement,
  imageIndex: number
): ImageInsertOption {
  const existing = getImageInsertOption(imageIndex);
  const widthAttr = Number(imgNode.getAttribute("data-vsk-image-width"));
  const alignAttr = String(
    imgNode.getAttribute("data-vsk-image-align") || ""
  ).toLowerCase();
  const style = String(imgNode.getAttribute("style") || "");
  const widthFromStyle = Number(
    (style.match(/width:\s*(\d+(?:\.\d+)?)%/i) || [])[1]
  );

  const width = Number.isFinite(widthAttr)
    ? widthAttr
    : Number.isFinite(widthFromStyle)
    ? widthFromStyle
    : existing.width;

  let align: ImageAlign = existing.align;
  if (alignAttr === "left" || alignAttr === "center" || alignAttr === "right") {
    align = alignAttr;
  } else if (/margin:\s*[^;]*auto\s+[^;]*0;?/i.test(style)) {
    align = "left";
  } else if (/margin:\s*[^;]*0\s+[^;]*auto;?/i.test(style)) {
    align = "right";
  } else if (/margin:\s*[^;]*auto[^;]*;?/i.test(style)) {
    align = "center";
  }

  const resolved: ImageInsertOption = {
    width: Math.min(90, Math.max(20, Math.round(width))),
    align,
  };
  imageInsertOptions.value[imageIndex] = resolved;
  return resolved;
}

function syncEditorToModel() {
  newPost.value.content = postContentEditor.value?.innerHTML || "";
}

function onEditorInput() {
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function insertHtmlAtCursor(html: string) {
  const editor = postContentEditor.value;
  if (!editor) return;
  editor.focus();
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) {
    editor.insertAdjacentHTML("beforeend", html);
    syncEditorToModel();
    return;
  }
  const range = sel.getRangeAt(0);
  range.deleteContents();
  const temp = document.createElement("div");
  temp.innerHTML = html;
  const fragment = document.createDocumentFragment();
  let node = temp.firstChild;
  while (node) {
    const next = node.nextSibling;
    fragment.appendChild(node);
    node = next;
  }
  range.insertNode(fragment);
  range.collapse(false);
  sel.removeAllRanges();
  sel.addRange(range);
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function applyEditorCommand(command: string, value?: string) {
  const editor = postContentEditor.value;
  if (!editor) return;
  editor.focus();
  let commandValue = value;
  if (command === "createLink") {
    const rawUrl = window.prompt("Hivatkozás URL-je:");
    if (!rawUrl) return;
    const trimmedUrl = rawUrl.trim();
    if (!/^https?:\/\//i.test(trimmedUrl)) {
      store.dispatch("setSnackbar", {
        title: "Érvénytelen link",
        text: "A hivatkozás http vagy https címmel kezdődjön.",
        color: "warning",
      });
      return;
    }
    commandValue = trimmedUrl;
  }
  document.execCommand(command, false, commandValue);
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function serializeEditorContentForBackend() {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = newPost.value.content || "";
  const images = wrapper.querySelectorAll("img");
  images.forEach((imgNode) => {
    const src = imgNode.getAttribute("src");
    if (!src) return;
    const imageIndex = imagePreviews.value.findIndex((url) => url === src);
    if (imageIndex < 0) return;
    const options = resolveImageInsertOptionFromNode(
      imgNode as HTMLImageElement,
      imageIndex
    );
    const token = `[[image:${imageIndex}|w:${options.width}|a:${options.align}]]`;
    imgNode.replaceWith(document.createTextNode(token));
  });
  return wrapper.innerHTML;
}

function refreshImagePreviews() {
  const nextUrls = selectedPostImages.value.map((file) => {
    const existingUrl = imagePreviewUrlByFile.get(file);
    if (existingUrl) return existingUrl;
    const nextUrl = URL.createObjectURL(file);
    imagePreviewUrlByFile.set(file, nextUrl);
    return nextUrl;
  });
  imagePreviews.value
    .filter((url) => !nextUrls.includes(url))
    .forEach((url) => URL.revokeObjectURL(url));
  imagePreviews.value = nextUrls;
}

function dataUrlToFile(dataUrl: string, fileName: string): File | null {
  const match = dataUrl.match(/^data:([^;,]+)(;base64)?,(.*)$/);
  if (!match) return null;
  const mimeType = match[1] || "image/png";
  const payload = match[3] || "";
  const binary = match[2]
    ? atob(payload)
    : decodeURIComponent(payload);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  const extension = mimeType.split("/")[1] || "png";
  return new File([bytes], `${fileName}.${extension}`, { type: mimeType });
}

async function resizeImageFile(
  file: File,
  maxEdge = MAX_UPLOAD_IMAGE_EDGE
): Promise<File> {
  if (!file.type.startsWith("image/")) return file;

  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("A kép olvasása sikertelen."));
    reader.readAsDataURL(file);
  });

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("A kép betöltése sikertelen."));
    image.src = dataUrl;
  });

  const longestEdge = Math.max(img.width, img.height);
  const ratio = longestEdge > maxEdge ? maxEdge / longestEdge : 1;
  const targetWidth = Math.max(1, Math.round(img.width * ratio));
  const targetHeight = Math.max(1, Math.round(img.height * ratio));

  if (ratio === 1) return file;

  const canvas = document.createElement("canvas");
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) return file;

  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", IMAGE_UPLOAD_QUALITY)
  );

  if (!blob) return file;

  return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
    type: "image/jpeg",
  });
}

function setCoverImageIndex(index: number) {
  selectedCoverImageIndex.value = index;
}

function insertImageToEditor(index: number) {
  const previewUrl = imagePreviews.value[index];
  if (!previewUrl) return;
  const options = getImageInsertOption(index);
  const imageHtml = `<img src="${previewUrl}" alt="Blog kép ${
    index + 1
  }" class="inline-editor-image" data-vsk-image-index="${index}" data-vsk-image-width="${
    options.width
  }" data-vsk-image-align="${options.align}" style="${buildImageInsertStyle(
    options.width,
    options.align
  )}" />`;
  insertHtmlAtCursor(imageHtml);
}

// ----------------- image handling -----------------
async function onImageSelect(e: Event) {
  const input = e.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;
  const pickedFiles = Array.from(input.files);
  const remainingSlots = Math.max(
    0,
    BLOG_IMAGE_MAX_COUNT - selectedPostImages.value.length
  );
  if (remainingSlots <= 0) {
    store.dispatch("setSnackbar", {
      title: "Képlimit elérve",
      text: `Maximum ${BLOG_IMAGE_MAX_COUNT} képet adhatsz a bejegyzéshez.`,
      color: "warning",
    });
    input.value = "";
    return;
  }

  const acceptedFiles = pickedFiles.slice(0, remainingSlots);
  if (acceptedFiles.length < pickedFiles.length) {
    store.dispatch("setSnackbar", {
      title: "Képlimit",
      text: `A megengedett képlimit miatt csak ${acceptedFiles.length} fájl került hozzáadásra.`,
      color: "warning",
    });
  }

  const optimizedFiles = await Promise.all(
    acceptedFiles.map((file) => resizeImageFile(file))
  );
  const startIndex = selectedPostImages.value.length;
  selectedPostImages.value = [...selectedPostImages.value, ...optimizedFiles];
  optimizedFiles.forEach((_, idx) => {
    getImageInsertOption(startIndex + idx);
  });
  refreshImagePreviews();
  input.value = "";
}

async function appendPostImages(files: File[]) {
  const imageFiles = files.filter((file) => file.type.startsWith("image/"));
  if (!imageFiles.length) return [] as number[];
  const remainingSlots = Math.max(
    0,
    BLOG_IMAGE_MAX_COUNT - selectedPostImages.value.length
  );
  if (remainingSlots <= 0) {
    store.dispatch("setSnackbar", {
      title: "Képlimit elérve",
      text: `Maximum ${BLOG_IMAGE_MAX_COUNT} képet adhatsz a bejegyzéshez.`,
      color: "warning",
    });
    return [] as number[];
  }

  const acceptedFiles = imageFiles.slice(0, remainingSlots);
  const optimizedFiles = await Promise.all(
    acceptedFiles.map((file) => resizeImageFile(file))
  );
  const startIndex = selectedPostImages.value.length;
  selectedPostImages.value = [...selectedPostImages.value, ...optimizedFiles];
  optimizedFiles.forEach((_, idx) => {
    getImageInsertOption(startIndex + idx);
  });
  refreshImagePreviews();
  return optimizedFiles.map((_, idx) => startIndex + idx);
}

async function onPostEditorPaste(event: ClipboardEvent) {
  const files = Array.from(event.clipboardData?.files || []).filter((file) =>
    file.type.startsWith("image/")
  );
  if (!files.length) return;
  event.preventDefault();
  const indexes = await appendPostImages(files);
  indexes.forEach((index) => insertImageToEditor(index));
}

async function materializeEmbeddedEditorImages() {
  const editor = postContentEditor.value;
  if (!editor) return;
  const images = Array.from(editor.querySelectorAll("img"));
  for (const imgNode of images) {
    const src = imgNode.getAttribute("src") || "";
    if (!src.startsWith("data:image/")) continue;
    const file = dataUrlToFile(src, `beillesztett-blog-kep-${Date.now()}`);
    if (!file) continue;
    const indexes = await appendPostImages([file]);
    const imageIndex = indexes[0];
    const previewUrl = imagePreviews.value[imageIndex];
    if (!previewUrl) continue;
    const options = getImageInsertOption(imageIndex);
    imgNode.setAttribute("src", previewUrl);
    imgNode.setAttribute("data-vsk-image-index", String(imageIndex));
    imgNode.setAttribute("data-vsk-image-width", String(options.width));
    imgNode.setAttribute("data-vsk-image-align", options.align);
    imgNode.setAttribute("style", buildImageInsertStyle(options.width, options.align));
  }
  syncEditorToModel();
}

function openPreviewImage(imageUrl: string) {
  if (!imageUrl) return;
  window.open(imageUrl, "_blank", "noopener,noreferrer");
}

function removeSelectedImage(index: number) {
  selectedPostImages.value.splice(index, 1);

  if (selectedCoverImageIndex.value === index) {
    selectedCoverImageIndex.value = null;
  } else if (
    selectedCoverImageIndex.value !== null &&
    selectedCoverImageIndex.value > index
  ) {
    selectedCoverImageIndex.value -= 1;
  }

  refreshImagePreviews();
}

// ----------------- categories update: új elemet adunk az availableCategories-hez ha kell ----------
function onCategoriesUpdate(newVal: string[]) {
  // minden kategória, ami nincs az availableCategories-ben, hozzáadjuk
  newVal.forEach((c) => {
    const normalized = c.trim();
    if (!normalized) return;
    if (!availableCategories.value.includes(normalized)) {
      availableCategories.value.push(normalized);
    }
  });
  newPost.value.categories = newVal.map((c) => c.trim()).filter(Boolean);
}

async function loadBlogCategories() {
  try {
    const res = await api.get("/blog/categories/");
    const items = res?.data?.responseData?.items;
    if (!Array.isArray(items)) return;

    blogCategories.value = items
      .map((item: any) => ({
        id: Number(item?.id || 0),
        name: String(item?.name || "").trim(),
      }))
      .filter(
        (item: any) => Number.isFinite(item.id) && item.id > 0 && item.name
      );

    const names = blogCategories.value.map((item) => item.name).filter(Boolean);

    availableCategories.value = Array.from(
      new Set([...availableCategories.value, ...names])
    );
  } catch (error) {
    console.warn("Kategóriák betöltése sikertelen:", error);
  }
}

// ----------------- create / save / cancel -----------------
async function createPost(targetStatus: "draft" | "published" = "published") {
  const hasTitle = Boolean(newPost.value.title?.trim());
  const hasContent = Boolean(newPost.value.content?.trim());
  if (!hasTitle || !hasContent) {
    store.dispatch("setAlert", {
      error: "A bejegyzés címe és tartalma is kötelező!",
    });
    return;
  }

  isBlogPostSubmitting.value = true;
  blogUploadProgress.value = 0;
  try {
    await materializeEmbeddedEditorImages();
    const serializedContent = serializeEditorContentForBackend();
    const payload = new FormData();
    payload.append("title", newPost.value.title);
    payload.append("content", serializedContent);
    payload.append("status", targetStatus);
    payload.append("categories", JSON.stringify(newPost.value.categories));
    if (newPost.value.imageUrl) {
      payload.append("cover_image", newPost.value.imageUrl);
    }
    if (selectedCoverImageIndex.value !== null) {
      payload.append("coverImageIndex", String(selectedCoverImageIndex.value));
    }
    selectedPostImages.value.forEach((file) => {
      payload.append("images", file);
    });

    const response = await api.post("/blog/post/", payload, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const total = Number(event?.total || 0);
        const loaded = Number(event?.loaded || 0);
        if (total > 0) {
          blogUploadProgress.value = Math.min(
            100,
            Math.max(1, Math.round((loaded / total) * 100))
          );
        } else {
          blogUploadProgress.value = 0;
        }
      },
    });

    const responseData = response.data;
    const createdPost = responseData?.responseData?.item;
    if (createdPost) {
      store.commit("ADD_POST", createdPost);
    }

    // Sikeres backend válasz (201 status) után:
    store.dispatch("setSnackbar", {
      // A backend válaszában lévő üzeneteket használhatjuk:
      title:
        responseData.responseData.messageTitle ||
        (targetStatus === "draft"
          ? "Piszkozat mentve"
          : "Blogbejegyzés létrehozva"),
      text:
        responseData.responseData.responseMessage ||
        (targetStatus === "draft"
          ? "A piszkozat mentése sikeres."
          : "A bejegyzés sikeresen elküldve."),
      color: "success",
    });

    // Űrlap visszaállítása és dialog bezárása
    resetPostForm();
    showPostDialog.value = false;

    if (targetStatus === "draft" && createdPost?.id) {
      await router.push(`/blog/${createdPost.slug || createdPost.id}/edit`);
      return;
    }
    await router.push({ name: "forum-page" });
    window.location.reload();
  } catch (err: any) {
    // 3. Hiba kezelése (pl. 4xx vagy 5xx status kód a backendről)

    // Megpróbáljuk beolvasni a backend által küldött hibaüzenetet,
    // ha a hiba struktúra ezt lehetővé teszi (pl. err.response.data.responseData.responseMessage)
    const backendMessage = err.response?.data?.responseData?.responseMessage;

    store.dispatch("setSnackbar", {
      title: "Hiba a bejegyzés létrehozásakor",
      text: backendMessage || err.message || "Ismeretlen hiba történt.",
      color: "error",
    });
  } finally {
    isBlogPostSubmitting.value = false;
    blogUploadProgress.value = 0;
  }
}

function onCancel() {
  resetPostForm();
  showPostDialog.value = false;
}

async function deleteBlogCategory(category: { id: number; name: string }) {
  if (!category?.id || isCategoryDeleting.value) return;
  isCategoryDeleting.value = true;
  try {
    await api.delete(`/blog/categories/${category.id}`);
    blogCategories.value = blogCategories.value.filter(
      (row) => row.id !== category.id
    );
    availableCategories.value = availableCategories.value.filter(
      (name) => name !== category.name
    );
    newPost.value.categories = newPost.value.categories.filter(
      (name) => name !== category.name
    );
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: "Kategória véglegesen törölve.",
      color: "success",
    });
  } catch (error: any) {
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text:
        error?.response?.data?.responseData?.responseMessage ||
        "A kategória törlése sikertelen.",
      color: "error",
    });
  } finally {
    isCategoryDeleting.value = false;
  }
}

function resetPostForm() {
  newPost.value = {
    title: "",
    content: "",
    imageUrl: "",
    categories: [],
  };
  imagePreviews.value.forEach((url) => URL.revokeObjectURL(url));
  imagePreviews.value = [];
  selectedPostImages.value = [];
  selectedCoverImageIndex.value = null;
  imageInsertOptions.value = {};
  if (postContentEditor.value) {
    postContentEditor.value.innerHTML = "";
  }
}

async function refreshStatisticsAccess() {
  if (!profile.value?.id) {
    canViewStatistics.value = false;
    return;
  }

  try {
    const response = await api.get("/profile/statistics-access");
    canViewStatistics.value = Boolean(response?.data?.responseData?.canView);
  } catch {
    canViewStatistics.value = false;
  }
}

// Lifecycle
onMounted(() => {
  const savedTheme = localStorage.getItem("currentTheme");
  if (savedTheme) {
    theme.global.name.value = savedTheme;
  }
  reloadFrontendStudioSettings();
  themeIcon.value =
    theme.global.name.value === "dark"
      ? "mdi-weather-sunny"
      : "mdi-weather-night";

  loadBlogCategories();
  refreshStatisticsAccess();
  document.addEventListener("selectionchange", onEditorSelectionChange);
  window.addEventListener("storage", reloadFrontendStudioSettings);
});

onBeforeUnmount(() => {
  document.removeEventListener("selectionchange", onEditorSelectionChange);
  window.removeEventListener("storage", reloadFrontendStudioSettings);
});

watch(showPostDialog, (visible) => {
  if (!visible) return;
  nextTick(() => {
    if (postContentEditor.value) {
      postContentEditor.value.innerHTML = newPost.value.content || "";
      refreshEditorToolbarState(
        postContentEditor.value,
        postEditorToolbarState
      );
    }
  });
});

watch(showGameDialog, (visible) => {
  if (!visible) return;
  nextTick(() => {
    if (gameDescriptionEditor.value) {
      gameDescriptionEditor.value.innerHTML = newGame.value.description || "";
      refreshEditorToolbarState(
        gameDescriptionEditor.value,
        gameEditorToolbarState
      );
    }
  });
});

watch(showMapDialog, (visible) => {
  if (visible) {
    nextTick(() => {
      if (mapDescriptionEditor.value) {
        mapDescriptionEditor.value.innerHTML = newMap.value.description || "";
        refreshEditorToolbarState(
          mapDescriptionEditor.value,
          mapEditorToolbarState
        );
      }
    });
    return;
  }

  if (!visible && !isMapSubmitting.value) {
    resetMapForm();
  }
});

watch(
  () => profile.value?.id,
  () => {
    refreshStatisticsAccess();
  }
);
</script>

<style scoped>
.app-main {
  background: radial-gradient(
      circle at 15% -10%,
      rgba(32, 156, 238, 0.14),
      transparent 30%
    ),
    radial-gradient(circle at 85% -5%, rgba(34, 197, 94, 0.12), transparent 28%),
    var(--v-theme-background);
}

.app-content {
  padding-bottom: 94px;
}

.main-app-bar {
  backdrop-filter: blur(14px);
  background: var(--app-nav-gradient);
  border-bottom: 1px solid var(--app-border);
}

.desktop-nav-shell {
  border: 1px solid var(--app-border);
  border-radius: 14px;
  padding: 4px 8px;
  background: var(--app-surface-elevated);
}

.desktop-tabs :deep(.v-tab) {
  min-width: 108px;
  border-radius: 10px;
  margin: 0 3px;
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--app-muted);
}

.desktop-tabs :deep(.v-tab--selected) {
  background: color-mix(in srgb, rgb(var(--v-theme-primary)) 18%, transparent);
  color: rgb(var(--v-theme-primary));
}

.desktop-tabs :deep(.v-slide-group__content) {
  align-items: center;
}

.modern-menu-list {
  border: 1px solid var(--app-border-strong);
  border-radius: 12px;
  padding: 6px;
  background-color: var(--app-surface-soft);
}

.desktop-user-chip {
  font-weight: 700;
}

.mobile-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  line-height: 1.1;
}

.mobile-brand-logo {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.25);
}

.mobile-brand-title {
  font-size: 0.96rem;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.mobile-brand-subtitle {
  font-size: 0.7rem;
  color: var(--app-soft-muted);
  font-weight: 600;
}

.mobile-drawer :deep(.v-navigation-drawer__content) {
  padding: 14px 12px 20px;
}

.mobile-drawer-header {
  border: 1px solid var(--app-border);
  border-radius: 16px;
  padding: 12px 14px;
  background: var(--app-hero-gradient);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.mobile-drawer-overline {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--app-soft-muted);
  font-weight: 700;
}

.mobile-drawer-title {
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.drawer-brand-logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  margin-bottom: 8px;
  object-fit: cover;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.24);
}

.mobile-quick-actions {
  display: grid;
  gap: 8px;
  margin-bottom: 10px;
}

.mobile-nav-list {
  border: 1px solid var(--app-border);
  border-radius: 14px;
  padding: 8px;
  background-color: var(--app-surface-soft);
}

.mobile-expansions {
  margin-top: 8px;
}

.mobile-bottom-nav {
  position: fixed;
  left: 10px;
  right: 10px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
  border: 1px solid var(--app-border-strong);
  border-radius: 18px;
  backdrop-filter: blur(12px);
  background-color: var(--app-surface) !important;
}

.mobile-bottom-nav :deep(.v-btn) {
  min-width: 0;
  font-size: 0.68rem;
  letter-spacing: 0.01em;
}

.mobile-bottom-nav :deep(.v-btn__content) {
  flex-direction: column;
  gap: 2px;
}

.profile-active {
  background-color: color-mix(
    in srgb,
    rgb(var(--v-theme-primary)) 16%,
    transparent
  );
  border-radius: 4px;
}
.editor-shell {
  border: 1px solid var(--app-border);
  border-radius: 8px;
  overflow: hidden;
}
.editor-toolbar {
  display: flex;
  gap: 6px;
  padding: 8px;
  align-items: center;
  background: var(--app-surface-soft);
  border-bottom: 1px solid var(--app-border);
}

.editor-body {
  padding: 12px;
  min-height: 220px;
}

.editor-contenteditable {
  width: 100%;
  min-height: 260px;
  padding: 12px;
  border: 1px solid var(--app-editor-border);
  border-radius: 8px;
  background: var(--app-editor-bg);
  font-size: 14px;
  line-height: 1.55;
  overflow: auto;
}

.editor-contenteditable:focus {
  outline: 2px solid
    color-mix(in srgb, var(--app-editor-accent) 35%, transparent);
  border-color: var(--app-editor-accent);
}

.editor-contenteditable :deep(img) {
  max-width: 100%;
}

.image-thumb {
  width: 160px;
  height: 120px;
  object-fit: cover;
  border-radius: 10px;
  border: 2px solid var(--app-border-strong);
  cursor: zoom-in;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.image-thumb-wrap {
  position: relative;
  width: 160px;
  display: flex;
  flex-direction: column;
}

.image-remove-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

.image-thumb--cover {
  border-color: var(--app-editor-accent);
  box-shadow: 0 0 0 3px
    color-mix(in srgb, var(--app-editor-accent) 24%, transparent);
}

.image-thumb-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.image-config-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.image-config-label {
  font-size: 11px;
  min-width: 34px;
  color: var(--app-soft-muted);
}

.image-config-input {
  width: 58px;
  height: 26px;
  border: 1px solid var(--app-border-strong);
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 12px;
}

.image-config-unit {
  font-size: 11px;
  color: var(--app-soft-muted);
}

.image-align-row {
  display: flex;
  gap: 4px;
}

.image-action-btn {
  width: 100%;
}

.image-caption {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--app-chip-text);
  text-align: center;
  background: var(--app-chip-bg);
  border: 1px solid var(--app-chip-border);
  border-radius: 6px;
  padding: 4px 6px;
}

.map-image-preview-wrap {
  max-width: 340px;
}

.map-image-preview {
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid var(--app-border-strong);
}

@media (min-width: 960px) {
  .app-content {
    padding-bottom: 24px;
  }

  .main-app-bar {
    margin: 10px 12px 0;
    border-radius: 14px;
  }
}
</style>
